__turbopack_context__.v({
  "bTitle": "styles-module__5NKfeq__bTitle",
  "background": "styles-module__5NKfeq__background",
  "backgroundMobile": "styles-module__5NKfeq__backgroundMobile",
  "card": "styles-module__5NKfeq__card",
  "checkboxContainer": "styles-module__5NKfeq__checkboxContainer",
  "confirm": "styles-module__5NKfeq__confirm",
  "contactContainer": "styles-module__5NKfeq__contactContainer",
  "content": "styles-module__5NKfeq__content",
  "dropdownMenu": "styles-module__5NKfeq__dropdownMenu",
  "ellipse": "styles-module__5NKfeq__ellipse",
  "form": "styles-module__5NKfeq__form",
  "header": "styles-module__5NKfeq__header",
  "listCard": "styles-module__5NKfeq__listCard",
  "mail": "styles-module__5NKfeq__mail",
  "title": "styles-module__5NKfeq__title",
});
